import styled from "@emotion/styled/macro";
import { Link } from "react-router-dom";
import headerMobile from "../../assets/images/aboutHeaderMobile.png";
import header from "../../assets/images/aboutHeader.png";
import { ContentLayout, BodyContentLayout } from "../../components/ui/ContentLayout";
import CardView from "../../components/pageParts/Cards/CardView";
import { useTranslation, Trans } from "react-i18next";
import FaqPart from "../Faq/FaqPart";
import PageHeader from "../../components/pageParts/PageHeader";
import bullet from "../../assets/images/bullet.svg";
import { Divider } from "@chakra-ui/react";
import Legal from "../Home/Legal";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${({ theme }) => theme.colors.white};
`;
const WhiteContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 3em 2em;
  }
  display: flex;
  flex-direction: column;
  padding: 0;
  line-height: 1.5em;
`;

const Subtitle = styled.h2`
  border-top: 1px solid ${({ theme }) => theme.colors.opal};
  padding-top: 2em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.6em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
    padding: 0;
  }
`;
const Know = styled.h2`
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.secondary};
`;
const Subsubtitle = styled.h3`
  padding-top: 2em;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.6em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
    padding: 0;
  }
`;
const Text = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.primary};
  & a {
    text-decoration: underline;
  }
`;

const StyledContentLayout = styled(ContentLayout)`
  z-index: 1;
  margin: 3em auto !important;
`;
const CardWrapper = styled.div``;

const Wrapper = styled.div`
  display: flex;
`;
const Parts = styled.div`
  padding-bottom: 4em;
`;
const SubPart = styled.div`
  padding-top: 2em;
`;
const Details = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-left: 4em;
    display: flex;
    flex-direction: column;
    width: fit-content;
  }
`;
const NavMenu = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 35%;
    flex-direction: column;
    display: flex;
  }
`;
const Bullets = styled.ul`
  padding-left: 2em;
  list-style: outside url(${bullet});
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
  li {
    padding: 0.5em 0;
  }
`;
const StyledDivider = styled(Divider)`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    border-color: ${({ theme }) => theme.colors.secondary};
    margin-bottom: 4em;
  }
`;
const MenuItem = styled.li`
  list-style: none;
  cursor: pointer;
  padding-bottom: 1em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-top: 1em;
    border-bottom: 1px solid ${({ theme }) => theme.colors.opal};
  }
`;

const About = () => {
  const { t } = useTranslation();
  const scroll = (scrollTo) => {
    document.querySelector(`#${scrollTo}`)?.scrollIntoView({
      behavior: "smooth",
    });
  };
  const cards = ["insurance", "abroad", "accident"];
  return (
    <Container>
      <PageHeader title={t("about.title")} text={t("about.info")} background={header} imgMobile={headerMobile} />
      <WhiteContainer>
        <BodyContentLayout>
          <Wrapper>
            <NavMenu>
              <ul>
                <MenuItem onClick={() => scroll("digital")}>{t("about.digital")}</MenuItem>
                <MenuItem onClick={() => scroll("developed")}>{t("about.developed.title")}</MenuItem>
                <MenuItem onClick={() => scroll("ownership")}>{t("about.ownership.title")}</MenuItem>
              </ul>
            </NavMenu>
            <Details>
              <Parts id="digital">
                <Subtitle>{t("about.digital")}</Subtitle>
                <Text>
                  <Trans i18nKey="about.digitalText">
                    phase. <br />
                    <br /> if about <br /> convenient right <br /> <br />
                    form. <br /> <br /> please
                  </Trans>
                </Text>
              </Parts>
              <StyledDivider />
              <Parts id="developed">
                <Subtitle>{t("about.developed.title")}</Subtitle>
                <Know>{t("about.developed.know")}</Know>
                <Bullets>
                  <li>{t("about.developed.bulletOne")}</li>
                  <li>{t("about.developed.bulletTwo")}</li>
                  <li>{t("about.developed.bulletThree")}</li>
                  <li>{t("about.developed.bulletFour")}</li>
                </Bullets>
                <SubPart>
                  <Subsubtitle>{t("about.developed.subtitle")}</Subsubtitle>
                  <Text>
                    <Trans i18nKey="about.developed.text">
                      <b>in first phase</b>
                      circulation <br /> <br />
                    </Trans>
                  </Text>
                </SubPart>
              </Parts>
              <StyledDivider />
              <Parts id="ownership">
                <Subtitle>{t("about.ownership.title")}</Subtitle>
                <Text>
                  <Trans i18nKey="about.ownership.ownershipIntro">
                    <br />
                  </Trans>
                </Text>
                <Bullets>
                  <li>
                    <Trans i18nKey="about.ownership.bulletone">
                      <b> </b> <br />
                      eec <br />
                    </Trans>
                  </li>
                  <li>
                    <Trans i18nKey="about.ownership.bulletTwo">
                      <b> </b> <br />
                      eec <br />
                    </Trans>
                  </li>
                  <li>
                    <Trans i18nKey="about.ownership.bulletThree">
                      <b> </b> <br />
                      eec <br />
                    </Trans>
                  </li>
                </Bullets>
                <SubPart>
                  <Text>
                    <Trans i18nKey="about.ownership.text">
                      <Link target="_blank" to={{ pathname: "https://www.fcgb-bgwf.be/" }}>
                        {""}
                      </Link>
                      <br />
                    </Trans>
                  </Text>
                </SubPart>
              </Parts>
            </Details>
          </Wrapper>
        </BodyContentLayout>
      </WhiteContainer>

      <Legal />
      <StyledContentLayout>
        <CardWrapper>
          <CardView cards={cards} />
        </CardWrapper>
      </StyledContentLayout>
      <FaqPart topic={t("header.secondaryMenu.about")} />
    </Container>
  );
};

export default About;
